import React, { FC } from 'react';
import { Message } from 'semantic-ui-react';
import { SidebarIcons } from '../../../types/sidebar';
import {
    CalendarIcon,
    DocumentsIcon,
    GreetingsIcon,
    HelloIcon,
    LinksIcon,
    MenuIcon,
    OrderIcon,
    SocialIcon,
    SurveyIcon,
    IconComponent,
} from '../../../neighbors/components/icons';
import "./style.less";

interface Props {
    white: boolean;
    name: SidebarIcons;
    height?: number;
    width?: number;
}

const iconMap: Partial<Record<SidebarIcons, IconComponent>> = {
    calendar: CalendarIcon,
    menu: MenuIcon,
    social: SocialIcon,
    documents: DocumentsIcon,
    links: LinksIcon,
    orderStatus: OrderIcon,
    survey: SurveyIcon,
    hello: HelloIcon,
    greetings: GreetingsIcon,
};

const SidebarIcon: FC<Props> = ({ name, white, height = 46, width = 42 }) => {
    const iconColor = white ? 'white' : '#2987CD';
    const Icon = iconMap[name];

    if (!Icon) return <Message error>Please provide a correct icon name</Message>;

    return <Icon style={{ color: iconColor, width, height }} />;
};

export default SidebarIcon;